import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Youtube } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    {/* Brand */}
                    <div className="footer-brand">
                        <h3 className="footer-logo">FISIO<span className="highlight">PEDROLA</span></h3>
                        <h3 className="footer-logo">FISIO<span className="highlight">PINSEQUE</span></h3>
                        <p className="footer-desc">
                            Tu salud en las mejores manos. Fisioterapia avanzada y personalizada para tu bienestar.
                        </p>
                        <div className="social-links">
                            <a href="https://www.instagram.com/fisioterapia_pinseque/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <Instagram size={20} />
                            </a>
                            <a href="https://www.youtube.com/channel/UC5NuzQwLQjJch544X0zQcmQ/videos" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                <Youtube size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Links */}
                    <div className="footer-links">
                        <h4>Enlaces</h4>
                        <ul>
                            <li><Link to="/clinica">La Clínica</Link></li>
                            <li><Link to="/equipo">Nuestro Equipo</Link></li>
                            <li><Link to="/tratamientos">Tratamientos</Link></li>
                            <li><Link to="/tarifas">Tarifas</Link></li>
                            <li><Link to="/formacion">Formación</Link></li>
                        </ul>
                    </div>

                    {/* Contact - Pinseque */}
                    <div className="footer-contact">
                        <h4>Fisioterapia Pinseque</h4>
                        <ul>
                            <li>
                                <MapPin size={18} className="icon" />
                                <span>C. San Pedro Mártir, 15, 50298 Pinseque, Zaragoza</span>
                            </li>
                            <li>
                                <Phone size={18} className="icon" />
                                <a href="tel:690051174">690 05 11 74</a>
                            </li>
                            <li>
                                <Mail size={18} className="icon" />
                                <a href="mailto:info@fisioterapiapinseque.com">info@fisioterapiapinseque.com</a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact - Pedrola */}
                    <div className="footer-contact">
                        <h4>Fisioterapia Pedrola</h4>
                        <ul>
                            <li>
                                <MapPin size={18} className="icon" />
                                <span>C. Zaragoza, 27, 50690 Pedrola, Zaragoza</span>
                            </li>
                            <li>
                                <Phone size={18} className="icon" />
                                <a href="tel:663881580">663 88 15 80</a>
                            </li>
                            <li>
                                <Mail size={18} className="icon" />
                                <a href="mailto:info@fisioterapiapinseque.com">info@fisioterapiapinseque.com</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} Fisioterapia Pedrola. Todos los derechos reservados.</p>
                    <div className="legal-links">
                        <Link to="/policy">Política de Privacidad</Link>
                        <Link to="/cookies">Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
